// src/store/actions/ComplaintsAction.js
import {
  getComplaints as svcGetComplaints,
  createComplaint as svcCreateComplaint,
  fetchComplaintById as svcFetchComplaintById,
  addComplaintReply as svcAddComplaintReply,
  getComplaintReplies as svcGetComplaintReplies,
} from '../../services/ComplaintsService';
import { formatSuccess, formatError } from '../../services/commonServices';

export const COMPLAINT_LIST_INITIATED = 'COMPLAINT_LIST_INITIATED';
export const COMPLAINT_INITIATED = 'COMPLAINT_INITIATED';
export const COMPLAINT_LIST_LOADED = 'COMPLAINT_LIST_LOADED';
export const COMPLAINT_LOADED = 'COMPLAINT_LOADED';
export const COMPLAINT_FAILED = 'COMPLAINT_FAILED';
export const COMPLAINT_REPLIES_INITIATED = 'COMPLAINT_REPLIES_INITIATED';
export const COMPLAINT_REPLIES_LOADED = 'COMPLAINT_REPLIES_LOADED';
export const COMPLAINT_REPLY_ADDED = 'COMPLAINT_REPLY_ADDED';

export const loadComplaints = (params) => {
  return (dispatch) => {
    dispatch({ type: COMPLAINT_LIST_INITIATED });
    return svcGetComplaints(params)
      .then((response) => {
        dispatch({ type: COMPLAINT_LIST_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: COMPLAINT_FAILED, payload: error.message });
      });
  };
};

export const getComplaintById = (id) => {
  return (dispatch) => {
    dispatch({ type: COMPLAINT_INITIATED });
    return svcFetchComplaintById(id)
      .then((response) => {
        dispatch({ type: COMPLAINT_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: COMPLAINT_FAILED, payload: error.message });
      });
  };
};

export const saveComplaintAction = (data, file = null, navigate = null) => {
  return async (dispatch) => {
    dispatch({ type: COMPLAINT_INITIATED });
    try {
      const res = await svcCreateComplaint(data, file);
      formatSuccess('Complaint', res.data);
      if (navigate) {
        setTimeout(() => navigate('/complaints'), 800);
      } else {
        dispatch({ type: COMPLAINT_LOADED, payload: res.data.data });
      }
      return res;
    } catch (error) {
      const fe = formatError(error?.response?.data || error);
      dispatch({ type: COMPLAINT_FAILED, payload: fe });
      throw error;
    }
  };
};

export const addComplaintReplyAction = (id, payload, file = null) => {
  return (dispatch) => {
    dispatch({ type: COMPLAINT_INITIATED });
    return svcAddComplaintReply(id, payload, file)
      .then((response) => {
        formatSuccess('Reply', response.data);
        dispatch({ type: COMPLAINT_REPLY_ADDED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: COMPLAINT_FAILED, payload: formatError(error?.response?.data || error) });
      });
  };
};

export const loadComplaintReplies = (id) => {
  return (dispatch) => {
    dispatch({ type: COMPLAINT_REPLIES_INITIATED });
    return svcGetComplaintReplies(id)
      .then((response) => {
        dispatch({ type: COMPLAINT_REPLIES_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: COMPLAINT_FAILED, payload: formatError(error?.response?.data || error) });
      });
  };
};
